const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]']);

/** Branding studio is local-dev only. */
export function isOroborosBrandingLocalhost(): boolean {
  if (typeof window === 'undefined') return false;
  return LOCALHOST_HOSTNAMES.has(window.location.hostname);
}
